import { useMemo } from 'react'
import config from '../../utils/config.json'
import { getPermissions } from '../../components/Common/Permissions'
import { useAuth } from '../../hooks/'
import { HeaderPage } from '../../components/Admin'
import "./HomeAdmin.scss"
import { Card, Icon } from 'semantic-ui-react'
import { BASE_API } from "../../utils/constantes"

function resolveCardHref(item) {
  if (item.external && item.externalBase === 'api') {
    return BASE_API + item.routing
  }
  return item.routing
}

function getCardColor(sectionId) {
  if (sectionId === 'lizen') return 'blue'
  if (sectionId === 'orion') return 'orange'
  return undefined
}

function DashboardCard({ item, sectionId }) {
  const cardColor = getCardColor(sectionId)
  const href = resolveCardHref(item)
  const isExternal = item.external

  return (
    <Card
      href={href}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      className={`cardPadre${cardColor ? ` cardHover--${cardColor}` : ''}`}
      color={cardColor}
    >
      <h4 className="cardContent">
        <span className="avatar"><Icon name={item.icon} /></span>
        <span className="nameCard">{item.name}</span>
        <span className="icon"><Icon name="arrow right" /></span>
      </h4>
    </Card>
  )
}

export function HomeAdmin() {
  const { auth } = useAuth()

  const visibleSections = useMemo(() => {
    return config.cardSections
      .map((section) => {
        const cards = config.cards.filter(
          (item) =>
            item.section === section.id &&
            item.active &&
            getPermissions(item.permissionName, auth)
        )
        return { ...section, cards }
      })
      .filter((section) => section.cards.length > 0)
  }, [auth])

  return (
    <>
      {visibleSections.map((section, index) => (
        <section
          key={section.id}
          aria-labelledby={`dashboard-section-${section.id}`}
          className={`dashboard-section${index === 0 ? ' dashboard-section--first' : ''}`}
        >
          <h3
            id={`dashboard-section-${section.id}`}
            className={`dashboard-section__title dashboard-section__title--${section.accent}`}
          >
            <Icon name={section.icon} className="dashboard-section__icon" />
            {section.title}
          </h3>
          <Card.Group>
            {section.cards.map((item) => (
              <DashboardCard key={item.name} item={item} sectionId={section.id} />
            ))}
          </Card.Group>
        </section>
      ))}
    </>
  )
}
